import { render, staticRenderFns } from "./DSArrowInsideCircleIcon.vue?vue&type=template&id=0a596e44&scoped=true&"
import script from "./DSArrowInsideCircleIcon.vue?vue&type=script&lang=js&"
export * from "./DSArrowInsideCircleIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a596e44",
  null
  
)

export default component.exports